
export default {
	created() {
	},
	methods: {
		$capitalizeFirstLetter(string) {
			return string.charAt(0).toUpperCase() + string.slice(1);
		}	
	}
}